import { useEffect, useMemo, useState } from 'react';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useCommerceComponents } from 'src/theme/provider/commerce-components/context';

import { ConciergeCustomizationSettings } from './concierge-theme';
import { readConciergeThemeTokens, ConciergeTokenPair } from './read-concierge-theme-tokens';
import { resolveConciergeSettings, ConciergeSettingsResolution } from './resolve-concierge-settings';

/**
 * The store's Concierge theme: partner tokens, then Admin
 * webCustomizationSettingsV2.concierge, then stock. Partner tokens are read in
 * an effect once the remote theme resolves, because getComputedStyle is
 * client-only and the Concierge route server-renders (ECOMM-11724).
 */
export function useConciergeTheme(): ConciergeSettingsResolution {
  const { dispensary } = useDispensary();
  const customization = dispensary?.webCustomizationSettingsV2?.concierge as
    | ConciergeCustomizationSettings
    | null
    | undefined;

  const { isRemoteThemeResolved } = useCommerceComponents();
  const [tokens, setTokens] = useState<ConciergeTokenPair | null>(null);

  useEffect(() => {
    if (isRemoteThemeResolved) {
      setTokens(readConciergeThemeTokens());
    }
  }, [isRemoteThemeResolved]);

  return useMemo(() => resolveConciergeSettings(tokens, customization), [tokens, customization]);
}
